<template>
    <OpportunityPageLayout class="OrgViewAdmin">
        <div class="gap-4 sm:flex sm:flex-col lg:flex-row">
            <div class="flex gap-4">
                <CThumbnailImage
                    :alt="org.title"
                    class="max-w-15 text-gray-750 dark:text-txt-headings"
                    :src="isOrgFieldVisible(org, 'image') ? org.image : ''"
                    type="org"
                />
                <div class="flex flex-col">
                    <CHeading class="mb-2" tag="h1" :variant="2">{{ org.title }}</CHeading>
                    <IconTextRow v-if="org.type" icon="organization">
                        {{ valueLookup(org.type, orgTypes) }}
                    </IconTextRow>
                </div>
            </div>
            <div class="mt-4 flex flex-col sm:mt-0 lg:ml-auto">
                <OrgViewMemberButtons :org="org" />
            </div>
        </div>

        <template #middle>
            <OrganizationActionCards class="mb-8" embedded :framed="false" :org-id="org.id" />

            <OrgOpportunitiesCount
                class="my-10"
                :jobs="jobs"
                :org-id="org.id"
                :projects="projects"
                show-actions
                :skills="skills"
            />

            <OrgMembers :org="org" />
        </template>
    </OpportunityPageLayout>
</template>

<script setup lang="ts">
import { valueLookup, orgTypes } from '#shared/types/dictionary'
import type { Org } from '#shared/types/Org'
import type { Job } from '#shared/types/Job'
import type { Project } from '#shared/types/Project'
import type { Skill } from '#shared/types/Skill'
import IconTextRow from '@/components/common/IconTextRow.vue'
import CHeading from '@/components/ui/CHeading.vue'
import CThumbnailImage from '@/components/ui/CThumbnailImage.vue'
import OpportunityPageLayout from '@/components/common/opportunity/OpportunityPageLayout.vue'
import OrgOpportunitiesCount from '@/components/orgs/OrgOpportunitiesCount.vue'
import OrgMembers from '@/components/orgs/OrgMembers.vue'
import OrgViewMemberButtons from '@/components/orgs/OrgViewMemberButtons.vue'
import OrganizationActionCards from '@/components/homepage/OrganizationActionCards.vue'
import { useOrgs } from '@/composables/orgs/useOrgs'

const { isOrgFieldVisible } = useOrgs()

const props = withDefaults(
    defineProps<{
        org: Org
        skills?: Skill[]
        projects?: Project[]
        jobs?: Job[]
    }>(),
    {
        skills: () => [],
        projects: () => [],
        jobs: () => []
    }
)
</script>
